var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrapper-layout',[_c('Header',{on:{"clicked":_vm.toggleSidebar}}),_c('base-layout',[_c('MainSidebar',{attrs:{"isToggled":_vm.isToggled}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }